export default [
  {
    id: '10002',
    status: 'A',
    jobId: 'greendale-qr-export-job-mock-id',
    // reportUrl: String
    totalStudents: 36,
    totalPages: 4,
  },
];
